<template>
  <div class="step-container scrollPosition">
    <div class="step-header">
      <h2 class="step-title">Zusatzflächen</h2>
      <p class="step-text">
        Geben Sie hier die Flächen der Ausstattungsdetails an.
      </p>
    </div>
    <div class="step-body">
      <div class="row gx-5 justify-content-center">
        <div
          class="col-md-6"
          v-if="isSet(readonly.flagKeller.value)"
        >
          <InputRange
            id="hs7b_s4"
            min="1"
            max="500"
            v-model="fields.hausKellerM2.value"
            :defaultValue="fields.hausKellerM2.default"
            label="Größe Keller / Lager / Nebengebäude"
            unit="m²"
            :state="fields.hausKellerM2.state"
            @update:modelValue="validate('hausKellerM2')"
          />
        </div>
      </div>
    </div>
    <div class="step-footer">
      <div class="row align-items-center">
        <div class="col-md-4 col-6">
          <button
            class="back-btn"
            @click="goBack()"
          >
            Zurück
          </button>
        </div>
        <div class="col-md-4 col-6 next-container">
          <button
            class="next-btn"
            @click="goNext()"
          >
            Weiter
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import InputRange from "@/components/shared/InputRange.vue";
import {
  getFromStorage,
  saveToStorage,
  isSet,
  checkValidFields,
  checkInvalidFields,
  containsInvalidFields,
  validateField,
  setDefaults,
getFieldFromStorage,
} from "@/utils.js";
export default {
  name: "haus-step-8b",
  components: {
    InputRange,
  },
  data() {
    return {
      fields: {
        hausKellerM2: {
          default: "50",
          validators: ["required", "min:1",`max: ${getFieldFromStorage("grundFlaeche")}`],
        },
      },
      readonly: {
        flagKeller: { value: null },
      },
    };
  },
  methods: {
    isSet: isSet,
    goBack() {
      setDefaults(this.fields);
      saveToStorage(this.fields);
      this.$router.push("/haus-step-8a");
    },
    goNext() {
      setDefaults(this.fields);
      checkInvalidFields(this.fields);
      if (!containsInvalidFields(this.fields)) {
        this.removeOtherValues();
        saveToStorage(this.fields);
        this.$router.push("/haus-step-9");
      }
    },
    validate(name) {
      const field = this.fields[name];
      field.state = validateField(field.value, field.validators);
    },
    //remove other values (f.e. hausKellerM2 if flagKeller is not set)
    removeOtherValues(){
      this.fields.hausKellerM2.value = isSet(this.readonly.flagKeller.value) ? this.fields.hausKellerM2.value : null;
    },
  },
  mounted() {
    this.$emit("setStep", "haus", 10);
    getFromStorage(this.readonly);
    getFromStorage(this.fields);
    checkValidFields(this.fields);
  },
};
</script>
<style scoped>
.step-body {
  margin-bottom: 55px;
}
.step-body .row {
  row-gap: 55px;
}
@media only screen and (max-width: 768px) {
  .step-body {
    margin-bottom: 55px;
  }
}
</style>
